/**************************************************
 * Nombre: Portada_Documentacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import fondo_portada_informacion from "../../../Recursos/fondo_portada_informacion.png";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import Propuesta_Valor_Portada_Documentacion from "./SubComponentes/Propuesta_Valor_Portada_Documentacion";


const Portada_Documentacion = () => {

    const {masSM} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
        >

            <Grid2 container size={12}
                   sx={{
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       backgroundImage: `linear-gradient(70deg, #000 20%, transparent 80%), url(${fondo_portada_informacion})`,
                       backgroundSize: "cover",
                       backgroundPosition: "center",
                       overflowX: 'hidden',
                   }}
            >
                <Grid2 container size={12}
                       sx={{maxWidth: "1400px", px: 3}}>

                    <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                        <Grid2 container size={masSM ? 7 : 12}
                               sx={{py: 20, mt: 8}}>
                            <Propuesta_Valor_Portada_Documentacion/>
                        </Grid2>

                        <Grid2 container size={masSM ? 6 : 12}>

                        </Grid2>
                    </Grid2>

                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Portada_Documentacion;